// extracted by mini-css-extract-plugin
export default {"viewGroupContainer":"viewGroup_viewGroupContainer__1OnTq","pageHeaderBreadcrumbs":"viewGroup_pageHeaderBreadcrumbs__q-n0H"};